import { c as _c } from "react/compiler-runtime";
import { Badge, Box, BoxProps, Button, Separator, Heading, HStack, Icon, Input, InputGroup, Link, SimpleGrid, Text, VStack, Field, Presence } from '@chakra-ui/react';
import { renderFileName } from '@src/components/sco/Account/UserSignupPitchDeckForm';
import { AutoResizeTextarea } from '@src/components/sco/AutoResizeTextarea';
import { CurrencyInput } from '@src/components/sco/CurrencyInput';
import { MarkdownRenderer } from '@src/components/sco/MarkdownRenderer';
import { Paragraph } from '@src/components/sco/Paragraph.tsx';
import { generateSignupRequestPreviewTitle } from '@src/components/sco/Requests/SignupRequestBuilder/helpers';
import { RichMarkdownInput } from '@src/components/sco/RichMarkdownInput';
import { ScoTagComboboxInput } from '@src/components/sco/ScoTagComboboxInput';
import { SelectableButtons } from '@src/components/sco/SelectableButtons';
import { TextLink } from '@src/components/sco/TextLink.tsx';
import { UploadDocumentButton } from '@src/components/sco/UploadDocumentButton';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { groupRequestTypesSelectableButtonOptions } from '@src/constants/group-request-types';
import { ScoSignupRequest } from '@src/graphql-types';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { scoBackendUrl } from '@src/lib/startups-url';
import { useEffect, useMemo, useState } from 'react';
import { LuArrowLeft, LuChevronRight, LuFileSearch, LuPencil, LuPencilLine, LuUpload } from 'react-icons/lu';
export const SignupRequestEditStep = props => {
  const $ = _c(49);
  const {
    borderRadius,
    signupRequest,
    updateSignupRequest,
    groupRequestType
  } = props;
  const {
    currentUser
  } = useCurrentUser();
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const [showPitchDeckUploader, setShowPitchDeckUploader] = useState(false);
  let t0;
  if ($[0] !== signupRequest) {
    t0 = generateSignupRequestPreviewTitle(signupRequest);
    $[0] = signupRequest;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const generatedPrompt = t0;
  let t1;
  if ($[2] !== groupRequestType?.key) {
    t1 = () => ({
      companyElevatorPitch: true,
      investorIndustryTagTitles: true,
      fundingGoalInDollars: ["funding"].includes(groupRequestType?.key),
      skillTagTitles: !["funding"].includes(groupRequestType?.key),
      bodyAsMarkdown: ["goal"].includes(groupRequestType?.key)
    });
    $[2] = groupRequestType?.key;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  groupRequestType?.key;
  let t2;
  if ($[4] !== t1) {
    t2 = t1();
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const showFormFields = t2;
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setShowPitchDeckUploader(false);
    };
    t4 = [];
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== getBreakpointValue) {
    t5 = getBreakpointValue([1, 1, 2]);
    $[8] = getBreakpointValue;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== getBreakpointValue) {
    t6 = getBreakpointValue([4, 6, 6, 8, 10]);
    $[10] = getBreakpointValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Badge variant="title">Create a Goal</Badge>;
    t8 = <Separator />;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== currentUser?.userId || $[15] !== getBreakpointValue || $[16] !== groupRequestType || $[17] !== showFormFields || $[18] !== showPitchDeckUploader || $[19] !== signupRequest.bodyAsMarkdown || $[20] !== signupRequest.companyElevatorPitch || $[21] !== signupRequest.fundingGoalInDollars || $[22] !== signupRequest.groupRequestTypeKey || $[23] !== signupRequest.investorIndustryTagTitles || $[24] !== signupRequest.pitchDeckUrl || $[25] !== signupRequest.skillTagTitles || $[26] !== updateSignupRequest) {
    t9 = <VStack align="stretch" gap={4} justify="stretch" width="full">{t7}{t8}{!signupRequest.groupRequestTypeKey ? <Field.Root><Heading>What do you want to accomplish?</Heading><SimpleGrid columns={getBreakpointValue([1, 2, 2, 3])} gap={getBreakpointValue([1, 1, 3])}><SelectableButtons defaultValue={[].filter(Boolean)} maxSelections={1} options={groupRequestTypesSelectableButtonOptions} onChange={selections => {
            if (selections?.length) {
              updateSignupRequest({
                groupRequestTypeKey: selections && selections[0]?.key
              });
            }
          }} /></SimpleGrid><Button marginTop={4} variant="outline" width="full" onClick={() => updateSignupRequest({
          groupRequestTypeKey: "goal"
        })}><LuPencilLine />Or, Define Your Own Goal</Button></Field.Root> : <Presence animationDuration="moderate" present={!!groupRequestType} animationName={{
        _open: "slide-from-bottom, fade-in",
        _closed: "slide-to-bottom, fade-out"
      }}><HStack justify="space-between" marginBottom={6}><HStack><Icon as={groupRequestType?.icon} color="colorPalette.fg/50" /><Text color="colorPalette.fg" textStyle="label">{groupRequestType?.label}</Text></HStack><Box><Button size="xs" variant="outline" onClick={() => updateSignupRequest({
              groupRequestTypeKey: null
            })}><LuPencil />Edit Request Type</Button></Box></HStack><VStack align="stretch" gap={6} justify="stretch" width="full">{showFormFields.bodyAsMarkdown && <Field.Root><Field.Label>What do you want to accomplish?</Field.Label><Box><RichMarkdownInput initialMarkdownValue={signupRequest.bodyAsMarkdown || ""} onChange={values => updateSignupRequest({
                bodyAsMarkdown: values.markdown
              })} /></Box></Field.Root>}{showFormFields.fundingGoalInDollars && <Field.Root><Field.Label>How much do you need to raise?</Field.Label><InputGroup startAddon="USD $"><Input asChild={true}><CurrencyInput numericValue={signupRequest.fundingGoalInDollars} onNumericValueChange={value => {
                  updateSignupRequest({
                    fundingGoalInDollars: value
                  });
                }} /></Input></InputGroup></Field.Root>}{showFormFields.investorIndustryTagTitles && <Field.Root><Field.Label>What industries are you in?</Field.Label><ScoTagComboboxInput defaultSelectedTagTitles={signupRequest.investorIndustryTagTitles} tagTypeKeys={["investor_industry"]} comboboxTagInputProps={{
              placeholder: "Search industries..."
            }} onSelectedTagsChange={tags => updateSignupRequest({
              investorIndustryTagTitles: tags.map(_temp)
            })} /></Field.Root>}{showFormFields.skillTagTitles && <Field.Root><Field.Label>{"What "}{groupRequestType?.skillTitle}{" skills are you looking for?"}</Field.Label><ScoTagComboboxInput defaultSelectedTagTitles={signupRequest.skillTagTitles} tagTypeKeys={["skill"]} comboboxTagInputProps={{
              placeholder: "Search skills..."
            }} onSelectedTagsChange={tags_0 => updateSignupRequest({
              skillTagTitles: tags_0.map(_temp2)
            })} /></Field.Root>}{showFormFields.companyElevatorPitch && <>{showPitchDeckUploader ? <Box backgroundColor="colorPalette.bg/50" border="1px solid" borderColor="whiteAlpha.100" borderRadius="md" padding="1.5em"><HStack gap="1em" justify="center" marginBottom="1em"><Icon as={LuUpload} fontSize="lg" />{signupRequest.pitchDeckUrl ? <Paragraph flexGrow={1} wordBreak="break-word"><TextLink href={signupRequest.pitchDeckUrl} target="_blank">{renderFileName(signupRequest.pitchDeckUrl)}</TextLink></Paragraph> : <Paragraph flexGrow={1}><strong>Upload Pitch Deck</strong> • PDF preferred, 40MB Max.</Paragraph>}</HStack>{signupRequest.pitchDeckUrl ? <Box borderTop="1px solid" borderTopColor="whiteAlpha.200" paddingTop="1em" textAlign="center"><Link variant="underline" onClick={() => updateSignupRequest({
                  pitchDeckUrl: null
                })}>Remove</Link></Box> : <><UploadDocumentButton uploadUrl={scoBackendUrl("/assets/upload-pitch-deck")} variant="solid" width="full" storedFile={{
                  attachmentType: "User",
                  attachmentId: currentUser?.userId,
                  contextKey: "investor-outreach-pitch-deck"
                }} onError={_temp3} onSuccess={url => updateSignupRequest({
                  pitchDeckUrl: url
                })}><LuFileSearch />Select File</UploadDocumentButton><Box textAlign="center"><Link fontSize="12px" opacity={0.5} variant="underline" _hover={{
                    opacity: 1
                  }} onClick={() => setShowPitchDeckUploader(false)}>Enter description instead</Link></Box></>}</Box> : <Field.Root><HStack align="flex-start" justify="space-between" width="full"><Field.Label>Briefly explain your startup:</Field.Label><Text fontSize="12px">{"or"}{" "}<Link fontWeight="bold" variant="underline" _hover={{
                    color: "white",
                    opacity: 1
                  }} onClick={() => setShowPitchDeckUploader(true)}>Upload Pitch Deck</Link></Text></HStack><AutoResizeTextarea value={signupRequest.companyElevatorPitch} onChange={e => updateSignupRequest({
                companyElevatorPitch: e.target.value
              })} /></Field.Root>}</>}</VStack></Presence>}</VStack>;
    $[14] = currentUser?.userId;
    $[15] = getBreakpointValue;
    $[16] = groupRequestType;
    $[17] = showFormFields;
    $[18] = showPitchDeckUploader;
    $[19] = signupRequest.bodyAsMarkdown;
    $[20] = signupRequest.companyElevatorPitch;
    $[21] = signupRequest.fundingGoalInDollars;
    $[22] = signupRequest.groupRequestTypeKey;
    $[23] = signupRequest.investorIndustryTagTitles;
    $[24] = signupRequest.pitchDeckUrl;
    $[25] = signupRequest.skillTagTitles;
    $[26] = updateSignupRequest;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t6 || $[29] !== t9) {
    t10 = <Box padding={t6}>{t9}</Box>;
    $[28] = t6;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== getBreakpointValue) {
    t11 = getBreakpointValue([4, 6, 6, 8, 12]);
    $[31] = getBreakpointValue;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== generatedPrompt) {
    t12 = <VStack align="stretch" bgColor="colorPalette.card" border="1px solid" borderColor="colorPalette.border/25" borderRadius="xl" flexGrow={1} justify="center" padding={6} textAlign="center">{generatedPrompt ? <MarkdownRenderer typographyStyles={{
        p: {
          lineHeight: 1.5,
          fontFamily: "Poppins",
          fontSize: "1.35em",
          textAlign: "center"
        }
      }}>{generatedPrompt}</MarkdownRenderer> : <HStack align="center" justify="center" width="full"><Icon as={LuArrowLeft} /><Text textAlign="center" textStyle="labelSm">Start by selecting what you want to accomplish...</Text></HStack>}</VStack>;
    $[33] = generatedPrompt;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== props) {
    t13 = () => {
      props.saveSignupRequest(() => props.setShowStep("preview"));
    };
    $[35] = props;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <LuChevronRight />;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t13) {
    t15 = <Button size="xl" variant="cta" onClick={t13}>Continue{t14}</Button>;
    $[38] = t13;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== borderRadius || $[41] !== t11 || $[42] !== t12 || $[43] !== t15) {
    t16 = <VStack align="stretch" bgColor="bg.darker" borderRightRadius={borderRadius} gap={6} padding={t11}>{t12}{t15}</VStack>;
    $[40] = borderRadius;
    $[41] = t11;
    $[42] = t12;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t10 || $[46] !== t16 || $[47] !== t5) {
    t17 = <SimpleGrid columns={t5}>{t10}{t16}</SimpleGrid>;
    $[45] = t10;
    $[46] = t16;
    $[47] = t5;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  return t17;
};
function _temp(t) {
  return t.title;
}
function _temp2(t_0) {
  return t_0.title;
}
function _temp3(err) {
  return alert(err?.toString() || "Upload failed.");
}